import Script from 'next/script'

type Props = {
  shouldLoad: boolean
}

// Turn off URL detection because AppCues detect a page change when we
// use the filter url sync to update the URL for CVT list view,
// opt for manually tracking page changes
// https://docs.appcues.com/en_US/install-appcues-web/single-page-application-spa-guide-developer
const APPCUES_INIT = `
window.AppcuesSettings = { enableURLDetection: false };
(function () {
  if (!window.AppcuesReady) {
    window.AppcuesReady = function (callback) {
      callback && window.AppcuesReady.q.push(callback);
      if (window.Appcues) {
        while (window.AppcuesReady.q.length) {
          var cb = window.AppcuesReady.q.shift();
          if (typeof cb === 'function') cb();
        }
      }
    };
    window.AppcuesReady.q = [];
  }
})();
`

const AppcuesIntegration = ({ shouldLoad }: Props) => {
  const accountId = process.env.NEXT_PUBLIC_APPCUES_ACCOUNT_ID

  if (!shouldLoad || !accountId) {
    return null
  }

  return (
    <>
      <Script id="appcues-init">{APPCUES_INIT}</Script>
      <Script
        src={`https://fast.appcues.com/${accountId}.js`}
        onLoad={() => window.AppcuesReady?.()}
      />
    </>
  )
}

export default AppcuesIntegration
